/* eslint-disable indent */
/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
Sai Maheshwar 11/25/2022 3031450488 added reportFields components
Guru Prasad 11/25/2022 3031450488 Fixed button alignments
Sohel 11/28/2022  3031450488 Added Date Format Field
Gummala Prakash 11/28/2022 3031450488 Fixed Button Alignment.
akhila 2/12/2022 3031450488 added Toaster for work-queue
Sai krishna 12/02/2022 2701350359 Fixed validation bug
Sai krishna 12/02/2022 2701350359 Fixed deleted ids bugs
Saikrishna 12/03/2022 3031450488 Fixed work queues account number field default.
Sai Maheshwar 12/03/2022 3031450488 added save and close in map fields
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Saikrishna 12/05/2022 3031450488 Fixed account field population issue.
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
kavya9reddy 12/08/2022 3031450488 Added save button
//akhila 12/08/2022 3075234474 changed toast message workqueue to Work Queue
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Sohel 12/13/2022 3031450488 fixed duplicate fields Added Issue
Sohel 12/13/2022 3031450488 conditionally hide Save Button
Ashraf 12/13/2022 3031450488 deleted ids issue and save and stay
Suresh Peddavoora 12/16/2022 3031450488 Fixed save button alignments
sai Krishna 12/23/2022 3031450488 add Work Queue code, Reportcode  and Work Queue description,Report description
Akhila 01/09/2023 3031450488 Fixed Double loader issue in  Popup dialog box in search Field
Ashraf 01/23/2023 3031450488 Added field header exist validation.
Akhila 03/03/2023 2692790263 bug fixed prepoulation issue record in work queue fiel step
Sohel 04/14/2023 3031450488 Added Field Length Validation and Payload Changes
Sohel  04/25/2023 2701127043 Added Data Calculation Field
Guru Prasad  04/25/2023 2701127043 Fixed button alignments
Sohel 05/12/2023 2700753823 Fixed Reset Select Fields issue
Sohel 05/15/2023 2700753823 Fixed default Account Number prepopulate Issue
Sohel 06/01/2023 2700753823 Fixed WorkQueue Account Number Prepopulate issue
Sohel 06/01/2023 2700753823 Worked Queue Duplicate Account Number Issue
Phanee 06/02/2023 2700753823 Work Queue Duplicate Render Issue
Sohel 06/02/2023 2700753823 Fixed prepoppulate issue
Sohel 06/03/2023 2700799562 Added Amount Format and Data Type Field
Ravi 06/20/2023 2700753823 Added Breadcrum in popup
Ravi 07/19/2023 3031450488  added data Calculation map fields
Ravi 07/19/2023 3031450488 modifield sort field popup
Ravi 07/20/2023 3031450488 Removed maped data calculation from sorts field table
*/
import { Button } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';
import DialogBox from '../../../../../components/DialogBox';
import FieldTable from '../Components/FieldTable';
import { Form, Formik } from 'formik';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import EditableDataTable from '../Components/EditableDataTable';
import AddIcon from '@material-ui/icons/Add';
import * as Yup from 'yup';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchBasicInfo,
  fetchReportFields,
  postReportFieldsDetails,
  resetMessage,
  resetReportFields,
  setReduxState,
} from '../../../../../redux/reducers/ReportMaster';
import { getFields } from '../Components/utils';
// import PageLoader from "../../../../../components/PageLoader";
import { ErrorSnackbar, SuccessSnackbar } from '../../../../../components/CustomSnackBar';
import { getDropDownData } from '../../../../../redux/reducers/BRE/AddReportMaster';
import { httpGet } from '../../../../../util/Rest';
import { REPORTING_EXPORT, WORK_QUEUE_SETUP } from '../../../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../../../util/BreadCrum';
import SearchDataCalculationFields from '../../../BRE/FormulaRuleGroup/SearchRuleGroup';
import { submissionStart } from '../../../../../redux/reducers/CommonActions/commonActions';
import DateFieldTable from '../Components/DateFieldTable';
import SelectSortFields from '../../../DataManager/DataManager/AddDataManager/SelectSortFields';
const ReportFields = ({ handleNext, handleBack, workQueue, handleDirty, editExisting }) => {
  const {
    reportCode,
    reportFieldsData,
    reportFieldsSortData,
    successMsg,
    errorMsg,
    reportFieldsPostStatus,
    fixedlength,
    basicInfoData,
    initialSave,
    reportDateStampFields,
  } = useSelector(({ reportMaster }) => reportMaster);

  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialVal = {
    field: '',
    name: '',
  };

  const [initialValues, setInitialValues] = useState(initialVal);
  const [mapFiledsDialog, setMapFieldListDialog] = useState(false);
  const [sortFiledsDialog, setSortFieldListDialog] = useState(false);
  const [dateStampDialog, setDateStampDialog] = useState(false);
  const [sortFiledsDialogs, setSortFieldListDialogs] = useState(false);
  // const [inputFieldValues, setInputFieldValues] = useState(initialState);
  const reportFieldsDeleteIdsRef = useRef([]);
  const sortFieldsDeleteIdsRef = useRef([]);
  const dateStampFieldDeleteRef = useRef([]);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [mapDataCalculation, setMapDataCalculation] = useState(false);
  const [sortFields, setSortFields] = useState([]);
  const [dateStampFields, setDateStampFields] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allSortFields, setAllSortFields] = useState([]);
  const [resetSortFields, setSortFieldsReset] = useState(false);
  const [disableSubTotal, setDisableSubTotal] = useState(true);
  const saveRef = useRef();
  const formRef = useRef();
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) : '';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return `${values}`;
    }
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const handleDataCalculationFields = () => {
    setMapDataCalculation(false);
  };
  useEffect(() => {
    if (reportFieldsData?.length > 0) {
      const sortedSeq = [...reportFieldsData].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        return {
          ...el,
          fieldName: el.fieldCode,
          ...getFields({ ...el, fieldName: el.fieldCode }),
        };
      });
      const initialVal = {};
      newSelectedRows?.forEach((r, i) => {
        const currField = r.fieldCode
          ? r.fieldCode + r.repositoryName
          : r.fieldName + r.repositoryName;
        initialVal['fieldLength' + currField] = r?.fieldWidth ? r?.fieldWidth : '';
        initialVal['dateFormat' + currField] = r?.dateFormat ? r?.dateFormat : '';
        initialVal['amountType' + currField] =
          r?.fieldType === 'Amount' ? (r?.amountType ? r?.amountType : 'With $') : '';
        initialVal['fieldHeader' + currField] = r?.fieldHeading
          ? r?.fieldHeading?.trim()
          : r.fieldLabel;
        initialVal['printSubTotal' + currField] = r?.printTotals ? r?.printTotals : 'N';
      });
      setInitialValues(initialVal);
      const condition = newSelectedRows.filter((item) => item.printTotals === 'Y')?.length > 0;
      setDisableSubTotal(!condition);

      // Remove duplicate fields
      const uniqueArray = newSelectedRows.filter(
        (value, index, self) => index === self.findIndex((t) => t.fieldCode === value.fieldCode),
      );
      setSelectedRows(uniqueArray);
    }
  }, [reportFieldsData]);

  useEffect(() => {
    if (selectedRows?.length === 0 && workQueue && basicInfoData?.lastStep === 1) {
      const url = `workqueu/get/all/repofield`;
      httpGet(url).then((response) => {
        const currentArr = [...selectedRows];
        const res = response?.response || [];
        const defaultFieldsData = [...res];
        let obj = {};
        Array.isArray(defaultFieldsData) &&
          defaultFieldsData?.forEach((item, i) => {
            const isAccNoExists = currentArr?.filter((row) => {
              return row.fieldName == item.fieldName && row.repositoryName == item.repositoryName;
            });
            if (!isAccNoExists?.length) {
              currentArr.push({
                ...item,
                fieldName: item.fieldName,
                ...getFields({ ...item, fieldName: item.fieldName }),
              });
            }
            const currField = item.fieldCode
              ? item.fieldCode + item.repositoryName
              : item.fieldName + item.repositoryName;
            const dynamicfieldNameHeader = 'fieldHeader' + currField;
            const dynamicfieldNamePrintTotal = 'printSubTotal' + currField;
            obj = {
              ...obj,
              [dynamicfieldNameHeader]: item.fieldName,
              [dynamicfieldNamePrintTotal]: 'N',
            };
          });
        setInitialValues((prevState) => {
          return {
            ...prevState,
            ...obj,
          };
        });
        setSelectedRows(currentArr);
      });
      dispatch(fetchReportFields(reportCode));
    }
  }, [selectedRows, initialSave, basicInfoData]);
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (reportFieldsSortData?.length > 0) {
      const sortedSeq = [...reportFieldsSortData].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        return {
          ...el,
          fieldName: el.fieldCode,
          sortOrder: el.decending,
          printTotal: el.subtotal,
        };
      });
      setSortFields(newSelectedRows);
    } else {
      setSortFields([]);
    }
  }, [reportFieldsSortData]);

  useEffect(() => {
    if (reportDateStampFields?.length > 0) {
      const sortedSeq = [...reportDateStampFields].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        return {
          ...el,
          dateValue: el?.value?.replace('cast(now()as date)', 'TODAY'),
        };
      });
      setDateStampFields(newSelectedRows);
    } else {
      setDateStampFields([]);
    }
    if (reportDateStampFields?.length > 0) {
      const initialVal = {};
      const sortedSeq = [...reportDateStampFields].sort((a, b) => a?.seqNum - b?.seqNum);
      sortedSeq?.forEach((r, i) => {
        const currField = r.fieldName + r.repositoryName;
        initialVal['dateValue' + currField] = r?.value
          ? r?.value?.replace('cast(now()as date)', 'TODAY')
          : '';
      });
      setInitialValues((prev) => ({ ...prev, ...initialVal }));
    }
  }, [reportDateStampFields]);
  useEffect(() => {
    // if (true) {
    const r = selectedRows
      ?.map((i) => {
        const fields = sortFields?.map((ele) => ele?.repositoryName + ele?.fieldName);
        if (fields?.includes(i?.repositoryName + i?.fieldName)) {
          return {
            ...i,
            tableData: { ...i.tableData, checked: true },
          };
        }
        return {
          ...i,
          tableData: { ...i.tableData, checked: false },
        };
      })
      ?.filter(
        (el) =>
          (el?.repositoryType || el?.repositoryName).toLowerCase() !== 'data calculation field',
      );
    setAllSortFields(r);
  }, [selectedRows, resetSortFields, sortFields]);
  useEffect(() => {
    if (reportFieldsPostStatus === 200) {
      setTimeout(() => {
        dispatch(setReduxState({ property: 'initialSave', value: false }));
        dispatch(resetReportFields());
        dispatch(resetMessage());
        if (!saveRef.current) {
          handleNext();
        } else {
          reportFieldsDeleteIdsRef.current = [];
          sortFieldsDeleteIdsRef.current = [];
          dateStampFieldDeleteRef.current = [];
        }
        dispatch(fetchReportFields(reportCode));
      }, 2000);
    }
  }, [reportFieldsPostStatus]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetReportFields());
      }, 2000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    if (reportCode) {
      dispatch(fetchReportFields(reportCode));
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);

  const shape = {};
  selectedRows?.forEach((r, i) => {
    const currField = r.fieldName + r.repositoryName;
    shape['fieldHeader' + currField] = Yup.string()
      .nullable()
      .required('Field Header is required')
      .test('fieldHeader' + currField, 'Field Header already exist', function (value) {
        const fieldHeaders = selectedRows?.map((i) => {
          if (i.fieldName + i.repositoryName !== r.fieldName + r.repositoryName) {
            return formRef?.current?.values['fieldHeader' + i.fieldName + i.repositoryName]?.trim();
          }
        });
        if (value && fieldHeaders?.includes(value?.trim())) {
          return false;
        } else {
          return true;
        }
      });
    shape['fieldLength' + currField] =
      fixedlength === 'Y'
        ? Yup.string()
            .nullable()
            .test('fieldLength', 'Field length is required', (value) => {
              return !(!value && fixedlength === 'Y');
            })
            .matches(/^0*[1-9]\d*$/, 'Field Length should be greater than or equal to 1')
            .test(
              'fieldLength',
              'Field Length Greater Than or equal to Field Header Length',
              (value, ctx) => {
                const field = 'fieldHeader' + currField;
                const length = 'fieldLength' + currField;
                if (value && ctx.parent[field]?.length <= Number(ctx.parent[length])) {
                  return true;
                } else {
                  return false;
                }
              },
            )
        : '';
  });

  const shape2 = {};
  dateStampFields?.forEach((r, i) => {
    const currField = r.fieldName + r.repositoryName;
    shape2['dateValue' + currField] = Yup.string().nullable().required('Date Stamp is required');
  });

  const validationSchema = Yup.object().shape({
    ...shape,
    ...shape2,
  });

  const handleClose = () => {
    setMapFieldListDialog(false);
  };

  const handleSortFieldDialog = () => {
    setSortFieldListDialog(false);
  };
  const handleDateStamDialog = () => {
    setDateStampDialog(false);
  };
  const handleSortFieldDialog1 = () => {
    setSortFieldListDialogs(false);
  };
  const { roleData } = useSelector(({ role }) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const roleAccess =
    (workQueue &&
      (reportFieldsData?.length > 0 || reportFieldsSortData?.length > 0) &&
      !workQueueSetupAccess?.edit &&
      editExisting) ||
    (!workQueue &&
      (reportFieldsData?.length > 0 || reportFieldsSortData?.length > 0) &&
      !reportRoleAccess?.edit &&
      editExisting);
  const handleSubmit = (data) => {
    dispatch(submissionStart());
    const fieldsList = selectedRows?.map((r, i) => {
      const field = {};
      const currField = r.fieldName + r.repositoryName;
      field['seqNum'] = i + 1;
      field['dateFormat'] = data['dateFormat' + currField] ? data['dateFormat' + currField] : '';
      field['amountType'] =
        r.fieldType === 'Amount'
          ? data['amountType' + currField]
            ? data['amountType' + currField]
            : 'With $'
          : '';
      field['fieldWidth'] = data['fieldLength' + currField]
        ? Number(data['fieldLength' + currField])
        : 0;
      field['fieldHeading'] = data['fieldHeader' + currField];
      field['repositoryName'] = r.repositoryName;
      field['fieldType'] = r.fieldType;
      field['printTotals'] = data['printSubTotal' + currField]
        ? data['printSubTotal' + currField]
        : '';
      field['fieldCode'] = r?.fieldName ? r.fieldName : '';
      field['reportFieldId'] = r.reportFieldId ? r.reportFieldId : 0;
      field['dataRepositoryId'] = r.dataRepositoryId ? r.dataRepositoryId : 0;
      field['fieldId'] = r.repositoryFieldId
        ? r.repositoryFieldId
        : r?.groupId
        ? r?.groupId
        : r?.fieldId
        ? r?.fieldId
        : 0;
      field['repositoryType'] =
        r?.groupId || (r?.repositoryType || '').toLowerCase() === 'data calculation field'
          ? 'DATA CALCULATION FIELD'
          : 'DB';
      return field;
    });
    const newFieldsData = fieldsList.map((el) => {
      if (el.fieldType === 'number' && el.fieldHeading?.length <= el.fieldWidth) {
        el.fieldHeading = ' '.repeat(el.fieldWidth - el.fieldHeading?.length) + el.fieldHeading;
      } else if (el.fieldHeading?.length <= el.fieldWidth) {
        el.fieldHeading = el.fieldHeading + ' '.repeat(el.fieldWidth - el.fieldHeading?.length);
      }
      return el;
    });
    const payload = {
      reportCode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
      reportId: reportCode ? reportCode : 0,
      reportFieldDeleteIds: reportFieldsDeleteIdsRef.current,
      reportDateStampFieldDeleteIds: dateStampFieldDeleteRef.current,
      reportFieldRequestList: fixedlength === 'Y' ? newFieldsData : fieldsList,
      reportSortFieldDeleteIds: sortFieldsDeleteIdsRef.current,
      lastStep: saveRef.current ? 1 : 2,
      reportSortedFields: sortFields?.map((each, i) => {
        return {
          decending: each.sortOrder,
          fieldCode: each?.fieldName,
          reportSortFieldsId: each?.reportSortFieldsId ? each?.reportSortFieldsId : 0,
          seqNum: i + 1,
          subtotal: each?.printTotal,
          repositoryName: each.repositoryName,
          fieldType: each.fieldType,
          dataRepositoryId: each?.dataRepositoryId ? each?.dataRepositoryId : 0,
          fieldId: each?.repositoryFieldId
            ? each?.repositoryFieldId
            : each?.fieldId
            ? each?.fieldId
            : 0,
          repositoryType: 'DB',
          // reportCode: reportCode,
        };
      }),
      reportDateStampFields: dateStampFields?.map((each, i) => {
        return {
          fieldName: each?.fieldName,
          reportDateStampId: each?.reportDateStampId ? each?.reportDateStampId : 0,
          seqNum: i + 1,
          repositoryName: each.repositoryName,
          fieldType: each.fieldType,
          value: each?.dateValue ? getValue(each?.dateValue) : '',
          dataRepositoryId: each?.dataRepositoryId ? each?.dataRepositoryId : 0,
          fieldId: each?.repositoryFieldId
            ? each?.repositoryFieldId
            : each?.fieldId
            ? each?.fieldId
            : 0,
          repositoryType: 'DB',
        };
      }),
    };
    dispatch(postReportFieldsDetails(payload));
  };
  const handlePrintTotal = (values) => {
    const condition = Object.entries(values).some(
      ([key, val]) => key.startsWith('printSubTotal') && val === 'Y',
    );
    setDisableSubTotal(!condition);
    if (!condition) {
      const newSortFields = sortFields.map((ele) => ({ ...ele, printTotal: 'N' }));
      setSortFields(newSortFields);
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
        innerRef={formRef}
      >
        {(props) => {
          const { values, setFieldValue, errors, touched, handleBlur, handleChange } = props;
          // handleDirty(dirty);
          return (
            <>
              {workQueue ? (
                <BreadCrums
                  name={'Work Queue Name'}
                  code={basicInfoData?.reportCode}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              ) : (
                <BreadCrums
                  name={'Report Name'}
                  code={basicInfoData?.reportCode}
                  description={'Report Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              )}
              <Form noValidate>
                <div className=" new-standard-textfields table-header table-card-header justify-content-end">
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => setMapFieldListDialog(true)}
                    startIcon={<AccountTreeIcon />}
                  >
                    Map Fields
                  </Button>
                  {/* {!workQueue && ( */}
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => setMapDataCalculation(true)}
                    startIcon={<AccountTreeIcon />}
                  >
                    Map Data Calculations Fields
                  </Button>
                  {/* )} */}
                </div>
                <FieldTable
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  // setFieldListApiData={setFieldListApiData}
                  // fieldListApiData={fieldListApiData}
                  errors={errors}
                  workQueue={workQueue}
                  handleDirty={handleDirty}
                  reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                  // inputFieldValues={inputFieldValues}
                  // setInputFieldValues={setInputFieldValues}
                  handleChange={handleChange}
                  sortFields={sortFields}
                  setSortFields={setSortFields}
                  sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                  handlePrintTotal={handlePrintTotal}
                  // deletedRules={deletedRules}
                  // setDeletedRules={setDeletedRules}
                  // fixedlength={fixedlength}
                />
                {!workQueue ? (
                  <div>
                    <div className="new-standard-textfields table-header table-card-header justify-content-end mt-3">
                      <Button
                        variant="outlined"
                        className={`search-btn ${classes.buttonRoot} ml-2`}
                        disabled={basicInfoData?.requireDateStamping === 'N'}
                        onClick={() => {
                          // const copyArr = [...sortFields];
                          // copyArr.push(dataObj);
                          // setSortFields(copyArr);
                          setDateStampDialog(true);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Date Stamp required
                      </Button>
                    </div>
                    <DateFieldTable
                      selectedRows={selectedRows}
                      dateStampFields={dateStampFields}
                      dateStampFieldDeleteRef={dateStampFieldDeleteRef}
                      setDateStampFields={setDateStampFields}
                      touched={touched}
                      values={values}
                      handleBlur={handleBlur}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      basicInfoData={basicInfoData}
                    />
                  </div>
                ) : (
                  ''
                )}
                <div className="table-header table-card-header justify-content-end mt-3 new-standard-textfields">
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} ml-2`}
                    onClick={() => {
                      // const copyArr = [...sortFields];
                      // copyArr.push(dataObj);
                      // setSortFields(copyArr);
                      setSortFieldListDialogs(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Sort Fields
                  </Button>
                </div>
                <EditableDataTable
                  selectedRows={selectedRows}
                  sortFields={sortFields}
                  sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                  setSortFields={setSortFields}
                  editExisting={editExisting}
                  DataManagerAccess={workQueue ? workQueueSetupAccess : reportRoleAccess}
                  disableSubTotal={disableSubTotal}
                />
                <div className="new-standard-textfields d-flex justify-content-center align-items-center mt-4">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    // disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  {/* {isDraftReport === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={!selectedRows?.length || roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
                <DialogBox
                  hideBackdrop={true}
                  open={sortFiledsDialogs}
                  dialogClose={handleSortFieldDialog1}
                  // title="Select Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Select Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SelectSortFields
                    sortFields={sortFields}
                    setSortFields={setSortFields}
                    isReports={true}
                    reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleSortFieldDialog1}
                    setSortFieldsReset={setSortFieldsReset}
                    handleDirty={handleDirty}
                    mapFields={true}
                    allSortFields={allSortFields}
                    setTempSelectedRows={setTempSelectedRows}
                    setAllSortFields={setAllSortFields}
                    resetSortFields={resetSortFields}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={mapFiledsDialog}
                  dialogClose={handleClose}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Map Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  {/* <SearchDataRepositoryFields
          handleClose={handleClose}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        /> */}
                  <SearchFields
                    selectedRows={selectedRows}
                    setReportFieldValue={setFieldValue}
                    setSelectedRows={setSelectedRows}
                    isReports={true}
                    mapFields={true}
                    reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    setTempSelectedRows={setTempSelectedRows}
                    workQueue={workQueue}
                    moduleName={workQueue ? 'WORK_QUEUE' : 'REPORT'}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={mapDataCalculation}
                  dialogClose={handleDataCalculationFields}
                  // title="Search Data Calculations Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Map Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchDataCalculationFields
                    selectedRows={selectedRows}
                    setReportFieldValue={setFieldValue}
                    setSelectedRows={setSelectedRows}
                    isReports={true}
                    mapFields={true}
                    reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleDataCalculationFields={handleDataCalculationFields}
                    setTempSelectedRows={setTempSelectedRows}
                    workQueue={workQueue}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={sortFiledsDialog}
                  dialogClose={handleSortFieldDialog}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  {/* <SearchDataRepositoryFields
          handleClose={handleClose}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        /> */}
                  <SearchFields
                    sortFields={sortFields}
                    setSortFields={setSortFields}
                    isReports={true}
                    reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleSortFieldDialog}
                    handleDirty={handleDirty}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={dateStampDialog}
                  dialogClose={handleDateStamDialog}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    dateStampFields={dateStampFields}
                    setDateStampFields={setDateStampFields}
                    isReports={true}
                    reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
                    dateStampFieldDeleteRef={dateStampFieldDeleteRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleDateStamDialog}
                    handleDirty={handleDirty}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                    reportDateStamp={true}
                  />
                </DialogBox>
              </Form>
            </>
          );
        }}
      </Formik>
      {/* {isLoading && <PageLoader />} */}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && (
        <SuccessSnackbar
          successMsg={
            workQueue ? 'Work Queue Fields Details added/modified Successfully' : successMsg
          }
        />
      )}
    </>
  );
};

export default React.memo(ReportFields);
